import { ExtensionOption } from '../../extension-register/models/extension-option.interface';

export interface ExtensionGroupMemberItemView extends ExtensionOption {
   extensionGroupExtensionId: number;
   extensionId: number;
}
export interface ExtensionGroupExtensionMemberSaveModel {
   extensionGroupExtensionId: number | null;
   extensionGroupId: number | null;
   extensionId: number | null;
}

export const extensionGroupMemberKeyFields: string[] = ['extensionGroupExtensionId', 'extensionGroupId', 'extensionId'];
